// src/App.js
import React, { useState } from "react";
import "./App.css";
import Nav from "./Views/Nav";
import DeliveryDate from "./Views/Date";
import CardClosed from "./Views/CardClosed";
import CardOpen from "./Views/CardOpen";
import CardInfo from "./Views/CardInfo";
import Cart from "./Views/Cart";
import Summary from "./Views/Summary";
import Payment from "./Views/Payment";
import Chicken from "./assets/images/chicken.png";
import chickenSalad from "./assets/images/chicken-salad.webp";
import boulettes from "./assets/images/boulettes.webp";
import carbonara from "./assets/images/carbonara.webp";
import chili from "./assets/images/chili.webp";
import chipotle from "./assets/images/chipotle.webp";
import grille from "./assets/images/grille.webp";
import mijote from "./assets/images/mijote.webp";
import pizza from "./assets/images/pizza.webp";
import poutine from "./assets/images/poutine.webp";
import ravioli from "./assets/images/ravioli.webp";
import rouleaux from "./assets/images/rouleaux.webp";
import saumon from "./assets/images/saumon.webp";
import steak from "./assets/images/steak.webp";
import tao from "./assets/images/tao.webp";
import toscane from "./assets/images/toscane.webp";

const MEALS = [
  {
    id: 1,
    image: Chicken,
    title: "Hauts de cuisse de poulet grillés miel et ail",
    tags: [
      { label: "Grillé", variant: "default" },
      { label: "Protéines", variant: "default" },
      { label: "Format familial", variant: "highlight" },
    ],
    description:
      "Hauts de cuisses de poulet grillés sur la flamme, couverts de notre glace salé-collante à l'ail et au miel. Le tout est servi avec notre trempette ranch relevée, des patates rôties et des légumes du marché.",
    ingredients:
      "Poulet miel et ail (cuisses de poulet, sucre (miel), eau, épices porchetta (gluten), ail, curcuma, jus de citron (sulfites)), Pommes de terre rôties (pommes de terre (sulfites), huile de canola, assaisonnement italien, paprika), Vinaigrette ranch (crème sûre, yogourt, babeurre, vinaigre de cidre de pomme, épices, persil, sel), Brocolis, Carottes",
    allergens: {
      contains: "Lait, Soja, Oeufs, Moutarde, Sulfites",
      mayContain: "Crustacés, Arachides, Poisson, Sésame",
    },
    nutrition: {
      totalWeight: "418 g",
      serving: "Pour ½ tasse (140g)",
      calories: 220,
      rows: [
        {
          label: "Lipides 14 g",
          bold: true,
          dv: "19%",
          subRows: [
            { label: "Saturés 3 g", dv: "15%" },
            { label: "+ Trans 0 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 12 g",
          bold: true,
          subRows: [
            { label: "Fibre 2 g", dv: "7%" },
            { label: "Sucres 3 g", dv: "3%" },
          ],
        },
        { label: "Protéines 14 g", bold: false },
        { label: "Cholestérol 45 mg", bold: false },
        { label: "Sodium 300 mg", bold: false, dv: "13%" },
        { label: "Potassium 400 mg", bold: false, dv: "12%" },
        { label: "Calcium 75 mg", bold: false, dv: "6%" },
        { label: "Fer 0.5 mg", bold: false, dv: "3%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 2,
    image: chickenSalad,
    title: "Salade de poulet grillé style BBQ",
    tags: [
      { label: "Grillé", variant: "default" },
      { label: "Légèrement épicé", variant: "default" },
      { label: "Sans ingrédient avec gluten", variant: "default" },
    ],
    description:
      "Poitrine de poulet BBQ, grillée sur la flamme et servie avec un mélange de légumes croquant. Le tout est arrosé de notre sauce onctueuse fumée et légèrement piquante, et garni de cheddar.",
    ingredients:
      " Poulet grillé (poitrine de poulet, eau, jus de lime, huile de canola, épices tex-mex, marinade (phosphate de sodium), sucre (cassonade), ail, poivre noir, saveur hickory), Pommes de terre, Sauce BBQ Alabama (mayonnaise, yogourt, moutarde à l'ancienne, raifort (sulfites), vinaigre de cidre de pomme, jus de citron (sulfites), ail, paprika fumé, épices cajun, sel), Chou, Maïs, Carottes, Radis, Chou frisé, Fromage cheddar",
    allergens: {
      contains: "Lait, Soja, Oeufs, Moutarde, Sulfites",
      mayContain: "Crustacés, Arachides, Poisson, Sésame",
    },
    nutrition: {
      totalWeight: "418 g",
      serving: "Pour ½ tasse (140g)",
      calories: 220,
      rows: [
        {
          label: "Lipides 14 g",
          bold: true,
          dv: "19%",
          subRows: [
            { label: "Saturés 3 g", dv: "15%" },
            { label: "+ Trans 0 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 12 g",
          bold: true,
          subRows: [
            { label: "Fibre 2 g", dv: "7%" },
            { label: "Sucres 3 g", dv: "3%" },
          ],
        },
        { label: "Protéines 14 g", bold: false },
        { label: "Cholestérol 45 mg", bold: false },
        { label: "Sodium 300 mg", bold: false, dv: "13%" },
        { label: "Potassium 400 mg", bold: false, dv: "12%" },
        { label: "Calcium 75 mg", bold: false, dv: "6%" },
        { label: "Fer 0.5 mg", bold: false, dv: "3%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 3,
    image: boulettes,
    title: "Boulettes de viande parmesan, sauce marinara",
    tags: [{ label: "Format familial", variant: "highlight" }],
    description:
      "Tendres boulettes à l'italienne maison, couvertes de notre sauce marinara réconfortante et légèrement acidulée. C'est servi sur des pâtes crémeuses au fromage et garni de parmesan. Ce plat est aussi copieux que satisfaisant.",
    ingredients:
      " Boulettes de viande (poulet haché, porc haché, fromage parmesan, purée de basilic, chapelure de pain (gluten), lait, herbes, épices, poudre de tomate, sel, vin blanc (sulfites)), Pâtes (pâtes (gluten), huile de canola), Sauce alfredo (lait, crème, fromage parmesan, vin blanc (sulfites), oignon, huile de canola, amidon de maïs, eau, ail, assaisonnement italien, sel, poivre noir), Sauce marinara (tomates broyées, eau, pâte de tomate, huile de canola, sel, ail, origan), Fromage mozzarella",
    allergens: {
      contains: "Lait, Gluten, Sulfites, Blé",
      mayContain:
        "Crustacés, Soja, Arachides, Poisson, Oeufs, Sésame, Moutarde",
    },
    nutrition: {
      totalWeight: "435 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 650,
      rows: [
        {
          label: "Lipides 39 g",
          bold: true,
          dv: "52%",
          subRows: [
            { label: "Saturés 12 g", dv: "63%" },
            { label: "+ Trans 0.5 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 38 g",
          bold: true,
          subRows: [
            { label: "Fibre 3 g", dv: "11%" },
            { label: "Sucres 5 g", dv: "5%" },
          ],
        },
        { label: "Protéines 35 g", bold: false },
        { label: "Cholestérol 120 mg", bold: false },
        { label: "Sodium 850 mg", bold: false, dv: "37%" },
        { label: "Potassium 600 mg", bold: false, dv: "18%" },
        { label: "Calcium 300 mg", bold: false, dv: "23%" },
        { label: "Fer 2.25 mg", bold: false, dv: "13%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 4,
    image: grille,
    title: "Bol de poulet grillé à la thaïe",
    tags: [
      { label: "Grillé", variant: "default" },
      { label: "Légèrement épicé", variant: "default" },
      { label: "Sans ingrédient avec gluten", variant: "default" },
      { label: "Format familial", variant: "highlight" },
    ],
    description:
      "Hauts de cuisses de poulet marinés au gingembre et à la lime, grillés sur la flamme et servis avec vermicelles, légumes croquants et arachides. Le tout est enrobé de notre vinaigrette maison épicée à la thaïe. ",
    ingredients:
      " Poulet à la thaïe (cuisses de poulet, sauce soya, purée de gingembre, jus de lime, sucre (cassonade), huile de canola, ail), Vermicelles de riz, Haricots verts, Vinaigrette thaïe épicée (huile de canola, vinaigre de riz, sucre (cassonade), sauce soya, huile de sésame, graines de sésame, purée de gingembre, sambal oelek (sulfites), gomme xanthane), Carottes, Arachides, Poivrons",
    allergens: {
      contains: "Soja, Arachides, Sésame, Sulfites",
      mayContain: "Lait, Crustacés, Poisson, Oeufs, Moutarde",
    },
    nutrition: {
      totalWeight: "435 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 530,
      rows: [
        {
          label: "Lipides 29 g",
          bold: true,
          dv: "39%",
          subRows: [
            { label: "Saturés 4 g", dv: "22%" },
            { label: "+ Trans 0.3 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 35 g",
          bold: true,
          subRows: [
            { label: "Fibre 4 g", dv: "14%" },
            { label: "Sucres 11 g", dv: "11%" },
          ],
        },
        { label: "Protéines 34 g", bold: false },
        { label: "Cholestérol 135 mg", bold: false },
        { label: "Sodium 530 mg", bold: false, dv: "23%" },
        { label: "Potassium 600 mg", bold: false, dv: "21%" },
        { label: "Calcium 50 mg", bold: false, dv: "4%" },
        { label: "Fer 2 mg", bold: false, dv: "11%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 5,
    image: mijote,
    title: "Mijoté de pois chiche",
    tags: [{ label: "Légèrement épicé", variant: "default" }],
    description:
      "Pois chiche mijotés doucement avec des tomates, des poivrons rôtis et des aubergines rôties. Les riches saveurs tomatées du mijoté, rehaussées avec du paprika fumé et du cumin, s'imprègnent dans le riz jasmin pour créer un plat des plus réconfortants.",
    ingredients:
      "Mijoté de pois chiche (tomates broyées, pois chiches, poivron rôti, aubergines assaisonnées (gluten, sulfites), oignon, ail, huile de canola, eau, épices, sel), Riz jasmin, Oignons rôtis (oignon, huile de canola, sel, poivre noir), Chou frisé",
    allergens: {
      contains: "Soja, Gluten, Sésame, Moutarde, Sulfites, Blé",
      mayContain:
        "Lait, Crustacés, Arachides, Poisson, Oeufs, Mollusques, Amandes, Pacanes, Noix de Grenoble, Noix de cajou",
    },
    nutrition: {
      totalWeight: "435 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 280,
      rows: [
        {
          label: "Lipides 8 g",
          bold: true,
          dv: "11%",
          subRows: [
            { label: "Saturés 0.5 g", dv: "3%" },
            { label: "+ Trans 0 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 46 g",
          bold: true,
          subRows: [
            { label: "Fibre 6 g", dv: "21%" },
            { label: "Sucres 7 g", dv: "7%" },
          ],
        },
        { label: "Protéines 7 g", bold: false },
        { label: "Cholestérol 0 mg", bold: false },
        { label: "Sodium 450 mg", bold: false, dv: "20%" },
        { label: "Potassium 200 mg", bold: false, dv: "6%" },
        { label: "Calcium 40 mg", bold: false, dv: "3%" },
        { label: "Fer 0.5 mg", bold: false, dv: "3%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 6,
    image: poutine,
    title: "Poutine de patates rôties style «chili cheese fries»",
    tags: [{ label: "Sans ingrédient avec gluten", variant: "default" }],
    description:
      "Patates rôties croustillantes avec des poivrons et des oignons grillés, nappés de notre savoureux chili au chorizo maison. Le tout est garni de fromage en grains et de Monterey Jack.",
    ingredients:
      "Pommes de terre rôties (pommes de terre (sulfites), huile de canola, épices à tacos, épices tex-mex), Chili de bœuf au chorizo (bœuf haché, eau, chorizo, oignons, demi-glace (sulfites), poivrons, maïs, haricots noir, pâte de tomate, purée d'origan, ail, sucre (cassonade), vinaigre de cidre de pomme, paprika, poudre de chipotle ancho, sel, saveur hickory), Fromage en grains, Poivrons, Oignons, Fromage Monterey Jack",
    allergens: {
      contains: "Lait, Soja, Sulfites",
      mayContain: "Crustacés, Arachides, Poisson, Oeufs, Sésame, Moutarde",
    },
    nutrition: {
      totalWeight: "435 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 500,
      rows: [
        {
          label: "Lipides 27 g",
          bold: true,
          dv: "36%",
          subRows: [
            { label: "Saturés 12 g", dv: "65%" },
            { label: "+ Trans 1 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 38 g",
          bold: true,
          subRows: [
            { label: "Fibre 4 g", dv: "14%" },
            { label: "Sucres 5 g", dv: "5%" },
          ],
        },
        { label: "Protéines 28 g", bold: false },
        { label: "Cholestérol 90 mg", bold: false },
        { label: "Sodium 700 mg", bold: false, dv: "30%" },
        { label: "Potassium 850 mg", bold: false, dv: "25%" },
        { label: "Calcium 350 mg", bold: false, dv: "27%" },
        { label: "Fer 2 mg", bold: false, dv: "11%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 7,
    image: ravioli,
    title: "Ravioli alla Gigi",
    tags: [],
    description:
      "Raviolis enrobés d'une sauce onctueuse à la crème, à la tomate, aux champignons et à l'ail avec de la pancetta croustillante.",
    ingredients:
      "Mini raviolis au fromage (semoule de blé dur (gluten), eau, fromage ricotta, fromage cheddar, fromage parmesan (lactosérum, lait, sel, acide citrique, chlorure de calcium, culture bactérienne, enzyme microbienne, cellulose, lipase), chapelure de blé grillée (gluten), œufs liquides entiers, flocons de pommes de terre, sel de mer, huile de canola, épices), Sauce gigi (champignons, lait, crème, tomates broyées, pâte de tomate, oignons, ail, sel, poivre noir), Pancetta",
    allergens: {
      contains: "Lait, Gluten, Oeufs, Blé",
      mayContain:
        "Crustacés, Soja, Arachides, Poisson, Sésame, Moutarde, Sulfites",
    },
    nutrition: {
      totalWeight: "407 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 630,
      rows: [
        {
          label: "Lipides 36 g",
          bold: true,
          dv: "48%",
          subRows: [
            { label: "Saturés 11 g", dv: "58%" },
            { label: "+ Trans 0.5 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 64 g",
          bold: true,
          subRows: [
            { label: "Fibre 4 g", dv: "14%" },
            { label: "Sucres 6 g", dv: "6%" },
          ],
        },
        { label: "Protéines 21 g", bold: false },
        { label: "Cholestérol 85 mg", bold: false },
        { label: "Sodium 1100 mg", bold: false, dv: "48%" },
        { label: "Potassium 600 mg", bold: false, dv: "18%" },
        { label: "Calcium 150 mg", bold: false, dv: "12%" },
        { label: "Fer 1.75 mg", bold: false, dv: "10%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 8,
    image: saumon,
    title: "Saumon rôti aux épices à steak, mayonnaise style béarnaise",
    tags: [{ label: "Sans ingrédient avec gluten", variant: "default" }],
    description:
      "Le «steak frites» de la mer. Pavé de saumon aux épices à steak de Montréal servi avec notre mayonnaise style béarnaise onctueuse, épicée et parfaite pour y tremper nos patates rôties. Le tout est accompagné de légumes du marché.",
    ingredients:
      "Saumon aux épices à steak (saumon, épices à steak, huile de canola), Pommes de terre rôties (pommes de terre (sulfites), huile de canola, assaisonnement italien), Céleri-rave, Mayonnaise béarnaise (mayonnaise, yogourt, oignon, vinaigre de vin rouge (sulfites), herbes, sel, Tabasco, poivre noir), Haricots verts",
    allergens: {
      contains: "Lait, Soja, Poisson, Oeufs, Moutarde, Sulfites",
      mayContain: "Crustacés, Arachides, Sésame",
    },
    nutrition: {
      totalWeight: "411 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 560,
      rows: [
        {
          label: "Lipides 34 g",
          bold: true,
          dv: "45%",
          subRows: [
            { label: "Saturés 7 g", dv: "35%" },
            { label: "+ Trans 0 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 28 g",
          bold: true,
          subRows: [
            { label: "Fibre 3 g", dv: "11%" },
            { label: "Sucres 5 g", dv: "5%" },
          ],
        },
        { label: "Protéines 34 g", bold: false },
        { label: "Cholestérol 85 mg", bold: false },
        { label: "Sodium 650 mg", bold: false, dv: "28%" },
        { label: "Potassium 1150 mg", bold: false, dv: "34%" },
        { label: "Calcium 75 mg", bold: false, dv: "6%" },
        { label: "Fer 1.25 mg", bold: false, dv: "7%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 9,
    image: steak,
    title: "Steak grillé à la teriyaki",
    tags: [{ label: "Grillé", variant: "default" }],
    description:
      "Steak et notre sauce teriyaki ensemble, la viande développe encore plus de saveurs. On la sert avec des légumes vapeur et des nouilles chow mein enrobées avec encore plus de sauce teriyaki, pour que tu aies ce beau côté relevé du sésame et du gingembre.",
    ingredients:
      "Steak de bœuf assaisonné (bœuf, huile de canola, épices à steak), Chowmein au hoisin (nouilles chowmein (gluten), carottes, chou, oignons, poivron, sauce hoisin sucrée (gluten), huile de canola), Edamame, Sauce hoisin sucrée (eau, sauce hoisin (gluten), sucre (miel), purée de gingembre, amidon de maïs, huile de sésame)",
    allergens: {
      contains: "Soja, Gluten, Sésame, Moutarde, Blé",
      mayContain: "Lait, Crustacés, Arachides, Poisson, Oeufs, Sulfites",
    },
    nutrition: {
      totalWeight: "413 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 600,
      rows: [
        {
          label: "Lipides 33 g",
          bold: true,
          dv: "44%",
          subRows: [
            { label: "Saturés 11 g", dv: "56%" },
            { label: "+ Trans 0.1 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 38 g",
          bold: true,
          subRows: [
            { label: "Fibre 2 g", dv: "7%" },
            { label: "Sucres 16 g", dv: "16%" },
          ],
        },
        { label: "Protéines 37 g", bold: false },
        { label: "Cholestérol 115 mg", bold: false },
        { label: "Sodium 620 mg", bold: false, dv: "27%" },
        { label: "Potassium 650 mg", bold: false, dv: "19%" },
        { label: "Calcium 40 mg", bold: false, dv: "3%" },
        { label: "Fer 4 mg", bold: false, dv: "22%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 10,
    image: pizza,
    title: "«Pizzaghetti»",
    tags: [{ label: "Format familial", variant: "highlight" }],
    description:
      "Steak et notre sauce teriyaki ensemble, la viande développe encore plus de saveurs. On la sert avec des légumes vapeur et des nouilles chow mein enrobées avec encore plus de sauce teriyaki, pour que tu aies ce beau côté relevé du sésame et du gingembre.",
    ingredients:
      "Steak de bœuf assaisonné (bœuf, huile de canola, épices à steak), Chowmein au hoisin (nouilles chowmein (gluten), carottes, chou, oignons, poivron, sauce hoisin sucrée (gluten), huile de canola), Edamame, Sauce hoisin sucrée (eau, sauce hoisin (gluten), sucre (miel), purée de gingembre, amidon de maïs, huile de sésame)",
    allergens: {
      contains: "Soja, Gluten, Sésame, Moutarde, Blé",
      mayContain: "Lait, Crustacés, Arachides, Poisson, Oeufs, Sulfites",
    },
    nutrition: {
      totalWeight: "413 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 600,
      rows: [
        {
          label: "Lipides 33 g",
          bold: true,
          dv: "44%",
          subRows: [
            { label: "Saturés 11 g", dv: "56%" },
            { label: "+ Trans 0.1 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 38 g",
          bold: true,
          subRows: [
            { label: "Fibre 2 g", dv: "7%" },
            { label: "Sucres 16 g", dv: "16%" },
          ],
        },
        { label: "Protéines 37 g", bold: false },
        { label: "Cholestérol 115 mg", bold: false },
        { label: "Sodium 620 mg", bold: false, dv: "27%" },
        { label: "Potassium 650 mg", bold: false, dv: "19%" },
        { label: "Calcium 40 mg", bold: false, dv: "3%" },
        { label: "Fer 4 mg", bold: false, dv: "22%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 11,
    image: rouleaux,
    title:
      "Salade «rouleaux de printemps» végétarienne avec sauce aux arachides épicée",
    tags: [
      { label: "Légèrement épicé", variant: "default" },
      { label: "Sans ingrédient avec gluten", variant: "default" },
    ],
    description:
      "Mélange de légumes croquants, sur un lit de vermicelles. C'est garni avec des edamame, des graines de sésame grillées et arrosé de notre vinaigrette au sésame sucrée-salée maison. Une salade aussi rafraîchissante que nourrissante.",
    ingredients:
      "Vermicelles de riz, Sauce arachide (beurre d'arachide, eau, vinaigre de cidre de pomme, lait de noix de coco, sucre (cassonade), sauce soya, pepperoncini mariné, gomme xanthane), Concombres, Maïs, Céleri, Chou, Edamame, Carottes, Chou frisé, Graines de sésame",
    allergens: {
      contains: "Soja, Arachides, Sésame",
      mayContain: "Lait, Crustacés, Poisson, Oeufs, Moutarde, Sulfites",
    },
    nutrition: {
      totalWeight: "401 g",
      serving: "Pour ½ tasse (140g)",
      calories: 140,
      rows: [
        {
          label: "Lipides 5 g",
          bold: true,
          dv: "7%",
          subRows: [
            { label: "Saturés 1.5 g", dv: "8%" },
            { label: "+ Trans 0 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 21 g",
          bold: true,
          subRows: [
            { label: "Fibre 3 g", dv: "11%" },
            { label: "Sucres 5 g", dv: "5%" },
          ],
        },
        { label: "Protéines 5 g", bold: false },
        { label: "Cholestérol 0 mg", bold: false },
        { label: "Sodium 170 mg", bold: false, dv: "7%" },
        { label: "Potassium 250 mg", bold: false, dv: "7%" },
        { label: "Calcium 40 mg", bold: false, dv: "3%" },
        { label: "Fer 1 mg", bold: false, dv: "6%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 12,
    image: chipotle,
    title: "Poulet chipotle avec sauce ranch",
    tags: [
      { label: "Sans ingrédient avec gluten", variant: "default" },
      { label: "Format familial", variant: "highlight" },
    ],
    description:
      "Hauts de cuisses de poulet marinés dans notre sauce BBQ chipotle maison, grillés sur la flamme et servis avec notre sauce ranch crémeuse, qui apporte une belle onctuosité au poulet. Le tout est accompagné de patates rôties et des légumes du marché.",
    ingredients:
      "Poulet BBQ chipotle (poitrine de poulet, ketchup, sucres (jus de pomme, sucre), piments chipotle, glaçage à l’abricot, eau, épices, jus de citron (sulfites), ail, saveur hickory, splenda sucralose), Pommes de terre rôties (pommes de terre (sulfites), huile de canola, épices tex-mex), Haricots verts, Vinaigrette ranch (crème sûre, yogourt, vinaigre de cidre de pomme, eau, épices, persil, oignons verts, sel), Carottes, Navets, Glaçage chipotle épicé (ketchup, sucres (jus de pomme, sucre), piment chipotle, eau, épices, jus de citron (sulfites), ail, saveur hickory, splenda sucralose)",
    allergens: {
      contains: "Lait, Sulfites",
      mayContain:
        "Crustacés, Soja, Arachides, Poisson, Oeufs, Sésame, Moutarde",
    },
    nutrition: {
      totalWeight: "445 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 310,
      rows: [
        {
          label: "Lipides 6 g",
          bold: true,
          dv: "8%",
          subRows: [
            { label: "Saturés 2 g", dv: "10%" },
            { label: "+ Trans 0 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 33 g",
          bold: true,
          subRows: [
            { label: "Fibre 4 g", dv: "14%" },
            { label: "Sucres 12 g", dv: "12%" },
          ],
        },
        { label: "Protéines 29 g", bold: false },
        { label: "Cholestérol 90 mg", bold: false },
        { label: "Sodium 410 mg", bold: false, dv: "18%" },
        { label: "Potassium 1000 mg", bold: false, dv: "29%" },
        { label: "Calcium 75 mg", bold: false, dv: "6%" },
        { label: "Fer 1.5 mg", bold: false, dv: "8%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 13,
    image: carbonara,
    title: "Pâtes alla carbonara",
    tags: [{ label: "Format familial", variant: "highlight" }],
    description:
      "Notre interprétation du classique; penne nappés de notre sauce crémeuse, le tout garni avec quantité généreuse de lardons fumés. Réconfortant et tellement savoureux.",
    ingredients:
      "Pâtes (pâtes (gluten), huile de canola), Sauce alfredo (lait, crème, fromage parmesan, vin blanc (sulfites), oignon, huile de canola, amidon de maïs, eau, ail, assaisonnement italien, sel, poivre noir), Bacon",
    allergens: {
      contains: "Lait, Gluten, Sulfites, Blé",
      mayContain:
        "Crustacés, Soja, Arachides, Poisson, Oeufs, Sésame, Moutarde",
    },
    nutrition: {
      totalWeight: "447 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 670,
      rows: [
        {
          label: "Lipides 39 g",
          bold: true,
          dv: "52%",
          subRows: [
            { label: "Saturés 12 g", dv: "65%" },
            { label: "+ Trans 1 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 62 g",
          bold: true,
          subRows: [
            { label: "Fibre 3 g", dv: "11%" },
            { label: "Sucres 6 g", dv: "6%" },
          ],
        },
        { label: "Protéines 18 g", bold: false },
        { label: "Cholestérol 60 mg", bold: false },
        { label: "Sodium 410 mg", bold: false, dv: "18%" },
        { label: "Potassium 175 mg", bold: false, dv: "5%" },
        { label: "Calcium 200 mg", bold: false, dv: "15%" },
        { label: "Fer 2.25 mg", bold: false, dv: "13%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 14,
    image: chili,
    title: "Chili de bœuf classique",
    tags: [],
    description:
      "Un copieux chili style texan; bœuf haché mijoté doucement avec des haricots rouges, du maïs et un mélange d'épices Tex-Mex. Servi avec du riz assaisonné Tex-Mex et des légumes du marché. Relevé et satisfaisant.",
    ingredients:
      "Chili de bœuf texan (bœuf haché, eau, haricots rouges, tomates broyées, maïs, céleri, poivrons assaisonnés (gluten, sulfites), oignons, pâte de tomate, demi-glace (sulfites), piments chipotle, épices tex-mex, cumin, amidon de maïs, ail, purée d'origan, saveur hickory), Riz texan (riz brun, tomates broyées, eau, oignons, sauce soya, ail, paprika, sel, poudre chipotle ancho), Haricots verts, Carottes, Maïs, Fromage cheddar",
    allergens: {
      contains: "Lait, Soja, Gluten, Sésame, Moutarde, Sulfites, Blé",
      mayContain:
        "Crustacés, Arachides, Poisson, Oeufs, Mollusques, Amandes, Pacanes, Noix de Grenoble, Noix de cajou",
    },
    nutrition: {
      totalWeight: "408 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 280,
      rows: [
        {
          label: "Lipides 9 g",
          bold: true,
          dv: "12%",
          subRows: [
            { label: "Saturés 3.5 g", dv: "19%" },
            { label: "+ Trans 0.2 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 32 g",
          bold: true,
          subRows: [
            { label: "Fibre 6 g", dv: "21%" },
            { label: "Sucres 7 g", dv: "7%" },
          ],
        },
        { label: "Protéines 16 g", bold: false },
        { label: "Cholestérol 40 mg", bold: false },
        { label: "Sodium 420 mg", bold: false, dv: "18%" },
        { label: "Potassium 650 mg", bold: false, dv: "19%" },
        { label: "Calcium 100 mg", bold: false, dv: "8%" },
        { label: "Fer 2.25 mg", bold: false, dv: "13%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
  {
    id: 15,
    image: tao,
    title: "Poulet général Tao",
    tags: [{ label: "Format familial", variant: "highlight" }],
    description:
      "Poitrine de poulet enrobée de notre délicieuse sauce Tao sucrée-salée et garnie de graines de sésame croustillantes. Le tout est servi sur du riz jasmin et des légumes vapeur. Un classique rempli de saveurs réconfortantes.",
    ingredients:
      "Poulet tao (poitrine de poulet, eau, pâte de tomate, ketchup, ail, purée de gingembre, sauce hoisin (gluten), sucre (cassonade), marinade (phosphate de sodium), sauce soya), Riz jasmin, Sauce Tao (eau, sucres (sucre blanc, cassonade), sauce soya, vinaigre de riz, sauce hoisin (gluten), purée de gingembre, amidon de maïs, épices, graines de sésame), Haricots verts, Carottes, Navets, Graines de sésame",
    allergens: {
      contains: "Soja, Gluten, Sésame, Blé",
      mayContain:
        "Lait, Crustacés, Arachides, Poisson, Oeufs, Moutarde, Sulfites",
    },
    nutrition: {
      totalWeight: "460 g",
      serving: "Pour 1½ tasse (300g)",
      calories: 350,
      rows: [
        {
          label: "Lipides 4.5 g",
          bold: true,
          dv: "6%",
          subRows: [
            { label: "Saturés 0.5 g", dv: "3%" },
            { label: "+ Trans 0 g", dv: "-" },
          ],
        },
        {
          label: "Glucides 46 g",
          bold: true,
          subRows: [
            { label: "Fibre 2 g", dv: "7%" },
            { label: "Sucres 18 g", dv: "18%" },
          ],
        },
        { label: "Protéines 32 g", bold: false },
        { label: "Cholestérol 90 mg", bold: false },
        { label: "Sodium 840 mg", bold: false, dv: "37%" },
        { label: "Potassium 700 mg", bold: false, dv: "21%" },
        { label: "Calcium 75 mg", bold: false, dv: "6%" },
        { label: "Fer 1.5 mg", bold: false, dv: "8%" },
      ],
      footer: "* 5% ou moins c'est peu, 15% ou plus c'est beaucoup",
    },
  },
];

function App() {
  const [activeStep, setActiveStep] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);
  const [mealQuantities, setMealQuantities] = useState({});
  const [infoMeal, setInfoMeal] = useState(null);
  const [mealSelections, setMealSelections] = useState({});
  // mealSelections[id] = Array<{ side: string, size: string }>

  const getMealQty = (id) => mealQuantities[id] || 0;

  const DEFAULT_SIDE = "Riz « frit » et légumes du marché";

  const setMealQty = (id, qty) => {
    setMealQuantities((prev) =>
      qty <= 0 ? { ...prev, [id]: 0 } : { ...prev, [id]: qty },
    );
    setMealSelections((prev) => {
      const current = prev[id] || [];
      if (qty <= 0) return { ...prev, [id]: [] };
      if (qty > current.length) {
        const added = Array.from({ length: qty - current.length }, () => ({
          side: DEFAULT_SIDE,
          size: "Régulier",
        }));
        return { ...prev, [id]: [...current, ...added] };
      }
      return { ...prev, [id]: current.slice(0, qty) };
    });
  };

  const handleSelectionsChange = (id, selections) =>
    setMealSelections((prev) => ({ ...prev, [id]: selections }));

  const handleIncrementCombo = (id, side, size) => {
    setMealQuantities((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
    setMealSelections((prev) => ({
      ...prev,
      [id]: [...(prev[id] || []), { side, size }],
    }));
  };

  const handleDecrementCombo = (id, side, size) => {
    setMealSelections((prev) => {
      const current = prev[id] || [];
      const lastIdx = current
        .map((s, i) => ({ s, i }))
        .filter(({ s }) => s.side === side && s.size === size)
        .pop()?.i;
      if (lastIdx === undefined) return prev;
      const next = [
        ...current.slice(0, lastIdx),
        ...current.slice(lastIdx + 1),
      ];
      return { ...prev, [id]: next };
    });
    setMealQuantities((prev) => ({
      ...prev,
      [id]: Math.max(0, (prev[id] || 0) - 1),
    }));
  };

  const mealsCount = Object.values(mealQuantities).reduce(
    (sum, q) => sum + q,
    0,
  );
  const [summaryOpen, setSummaryOpen] = useState(false);

  const handleDateConfirm = (date) => {
    setSelectedDate(date);
    setActiveStep(1);
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
      <Nav activeStep={activeStep} onStepClick={setActiveStep} />
      {activeStep === 0 && <DeliveryDate onConfirm={handleDateConfirm} />}
      {activeStep === 1 && (
        <>
          <div className="header">Construisez votre commande</div>
          <div className="h3">
            Choisissez vos repas, collations et autres items.
          </div>
          <div className="cards-row">
            {MEALS.map((meal) =>
              getMealQty(meal.id) > 0 ? (
                <CardOpen
                  key={meal.id}
                  image={meal.image}
                  title={meal.title}
                  tags={meal.tags}
                  quantity={getMealQty(meal.id)}
                  onIncrement={() =>
                    setMealQty(meal.id, getMealQty(meal.id) + 1)
                  }
                  onDecrement={() =>
                    setMealQty(meal.id, getMealQty(meal.id) - 1)
                  }
                  onSelectionsChange={(sels) =>
                    handleSelectionsChange(meal.id, sels)
                  }
                  onInfoClick={() => setInfoMeal(meal)}
                />
              ) : (
                <CardClosed
                  key={meal.id}
                  image={meal.image}
                  title={meal.title}
                  tags={meal.tags}
                  onAdd={() => setMealQty(meal.id, 1)}
                  onInfoClick={() => setInfoMeal(meal)}
                />
              ),
            )}
          </div>
          <Cart
            mealsCount={mealsCount}
            onConfirm={() => {
              setActiveStep(2);
              window.scrollTo(0, 0);
            }}
            onClick={() => setSummaryOpen(true)}
          />
          <Summary
            isOpen={summaryOpen}
            onClose={() => setSummaryOpen(false)}
            meals={MEALS}
            mealQuantities={mealQuantities}
            mealSelections={mealSelections}
            onConfirm={() => {
              setActiveStep(2);
              window.scrollTo(0, 0);
            }}
            onIncrementCombo={handleIncrementCombo}
            onDecrementCombo={handleDecrementCombo}
          />
        </>
      )}
      {activeStep === 2 && (
        <Payment
          meals={MEALS}
          mealQuantities={mealQuantities}
          mealSelections={mealSelections}
          deliveryDate={selectedDate}
          onModifyDate={() => setActiveStep(0)}
          onModifyMeals={() => setActiveStep(1)}
        />
      )}
      {infoMeal && (
        <CardInfo meal={infoMeal} onClose={() => setInfoMeal(null)} />
      )}
    </div>
  );
}
export default App;
